ObjectUtils.define('UIFrontPageFeaturesController', UIController, {

  didClick: function didClick(container, target) {
    if (DOM.maybeFindParentByClass(target, 'UICategories')) {
      return EventDelegater.STOP;
    }

    return EventDelegater.FORWARD;
  }
});
